<template>
  <div class="v-multiRangeSlider">
    <div class="v-dummySlider">
      <div class="v-dummySlider__track"></div>
      <div class="v-dummySlider__range" :style="{ 'left': leftPos + '%', 'right': rightPos + '%' }"></div>
      <div class="v-dummySlider__thumb -left" :style="{ 'left': leftPos + '%' }"></div>
      <div class="v-dummySlider__thumb -right" :style="{ 'right': rightPos + '%' }"></div>
    </div>
    <input
      type="range" :min="rangeMin" :max="rangeMax"
      class="v-multiRangeSlider__input"
      @input="setLeftValue"
      @mouseup="onFormChange"
      v-model.number="leftValue"
      :dataValue="leftValue"
    >
    <input
      type="range" :min="rangeMin" :max="rangeMax"
      class="v-multiRangeSlider__input"
      @input="setRightValue"
      @mouseup="onFormChange"
      v-model.number="rightValue"
      :dataValue="rightValue"
    >
  </div>
</template>

<script>
export default {
  name: 'MultiRangeSlider',
  props: {
    name: {
      type: String,
      required: true,
    },
    minValue: {
      type: Number,
      required: true,
    },
    maxValue: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      
      stepSettings: {
        // price
        price: [
          {
            step: 5000,
            price_threshold: 300000,
            value_threshold: null,
          },
          {
            step: 10000,
            price_threshold: 500000,
            value_threshold: null,
          },
          {
            step: 50000,
            price_threshold: 1000000,
            value_threshold: null,
          },
          {
            step: 250000,
            price_threshold: 10000000,
            value_threshold: null,
          },
          {
            step: 1000000,
            price_threshold: this.max,
            value_threshold: null,
          },
        ],
        // carat
        carat: [
          {
            step: 0.001,
            price_threshold: 0.500,
            value_threshold: null,
          },
          {
            step: 0.010,
            price_threshold: 1.500,
            value_threshold: null,
          },
          {
            step: 0.100,
            price_threshold: this.max,
            value_threshold: null,
          },
        ]
      }
    }
  },
  computed: {
    stepSetting: function () {
      return this.stepSettings[this.name];
    },
    rangeMin: function () {
      return this.encodeValue(this.min);
    },
    rangeMax: function () {
      return this.encodeValue(this.max);
    },
    leftValue: {
      get(){
        const rangeValue = this.encodeValue(this.minValue);
        return rangeValue;
      },
      set(value){
        const price = this.decodeValue(value);
        this.$emit('changeMinValue', parseFloat(price));
      }
    },
    rightValue: {
      get(){
        let rangeValue = this.encodeValue(this.maxValue);
        rangeValue = Math.min(this.stepSetting.slice(-1)[0].value_threshold, rangeValue);
        return rangeValue;
      },
      set(value){
        const price = this.decodeValue(value);
        this.$emit('changeMaxValue', parseFloat(price));
      }
    },
    // ダミースライダーのスタイル用
    leftPos: function () {
      let percent = ((this.leftValue - this.rangeMin) / (this.rangeMax - this.rangeMin)) * 100;
      percent = Math.max(0, percent);
      return percent;
    },
    // ダミースライダーのスタイル用
    rightPos: function () {
      let percent = ((this.rightValue - this.rangeMin) / (this.rangeMax - this.rangeMin)) * 100;
      percent = 100 - percent;
      percent = Math.max(0, percent);
      return percent;
    }
  },
  methods: {
    onFormChange () {
      this.$emit('onFormChange');
    },
    // 右のハンドルより大きくならないように
    setLeftValue () {
      if (this.leftValue >= this.rightValue-1) {
        this.leftValue = this.rightValue-1;
      }
    },
    // TODO: 左のハンドルより小さくならないように
    setRightValue () {
      /*
      if (this.leftValue+1 > this.rightValue) {
        this.rightValue = this.leftValue+1;
      }
      */
    },
    // 閾値の計算
    setValueThreshold () {
      for (let i = 0, len = this.stepSetting.length; i < len; i=(i+1)|0) {
        let previousPriceThreshold = this.min,
            previousValueThreshold = 0;

        if (i > 0) {
          previousPriceThreshold = this.stepSetting[i-1].price_threshold
          previousValueThreshold = this.stepSetting[i-1].value_threshold
        }

        const currentCount = ((this.stepSetting[i].price_threshold - previousPriceThreshold) / this.stepSetting[i].step)
        const value_threshold = previousValueThreshold + currentCount
        
        this.stepSetting[i].value_threshold = value_threshold;
      }
    },
    // 値を価格に変換
    decodeValue (value) {
      // 70
      // 70 - 60 = 10
      // 10 * 10000 = 100000
      // 100000 + 300000 = 400000
      // 400000

      let price = 0;
      for (let i = 0, len = this.stepSetting.length; i < len; i=(i+1)|0) {
        if (value > this.stepSetting[i].value_threshold && i < len-1) {
          continue;
        }

        let previousPriceThreshold = this.min,
            previousValueThreshold = 0;

        if (i > 0) {
          previousPriceThreshold = this.stepSetting[i-1].price_threshold;
          previousValueThreshold = this.stepSetting[i-1].value_threshold;
        }

        price = previousPriceThreshold + (( value - previousValueThreshold ) * this.stepSetting[i].step);

        // caratの場合、小数点3位以下を四捨五入
        if (this.name === "carat"){
          price = Math.round(price * 1000) / 1000;
        }

        break;
      }

      return price;
    },
    // 価格を値に変換
    encodeValue (price) {
      // 400000
      // 400000 - 300000 = 100000
      // 100000 / 10000 = 10
      // 10 + 60 = 70
      // 70

      let value = 0;
      for (let i = 0, len = this.stepSetting.length; i < len; i=(i+1)|0) {
        if (price > this.stepSetting[i].price_threshold && i < len-1) {
          continue;
        }

        let previousPriceThreshold = this.min,
            previousValueThreshold = 0;

        if (i > 0) {
          previousPriceThreshold = this.stepSetting[i-1].price_threshold;
          previousValueThreshold = this.stepSetting[i-1].value_threshold;
        }

        value = ( price - previousPriceThreshold ) / this.stepSetting[i].step + previousValueThreshold;

        break;
      }

      return value;
    }
  },
  created() {
    this.setValueThreshold();
  },
}
</script>

<style lang="scss" scoped>
  // multi input slider
  .v-multiRangeSlider {
    margin: 20px 0;
    position: relative;

    &__input {
      position: absolute;
      top: 0;
      pointer-events: none;
      -webkit-appearance: none;
      height: 4px;
      width: 100%;
      opacity: 0;

      &::-webkit-slider-thumb {
        cursor: pointer;
        pointer-events: all;
        width: 30px;
        height: 30px;
        border-radius: 0;
        border: 0 none;
        background-color: red;
        -webkit-appearance: none;
        position: relative;
        z-index: 2;
      }

      &+&::-webkit-slider-thumb {
        background-color: blue;
      }
    }
  }

  .v-dummySlider {
    position: relative;
    height: 4px;
    margin: 0 15px;

    &__track {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      border-radius: 5px;
      background-color: #f1f1f1;
    }

    &__range {
      position: absolute;
      left: 25%;
      right: 25%;
      top: 0;
      bottom: 0;
      border-radius: 5px;
      background-color: #667c8b;
    }

    &__thumb {
      position: absolute;
      width: 16px;
      height: 16px;
      background-color: #2a475a;
      border-radius: 50%;
      box-shadow: 0 0 0 0 rgba(98,0,238,.1);
      transition: box-shadow .3s ease-in-out;

      &.-left {
        left: 25%;
        transform: translate(-8px, -6px);
      }

      &.-right {
        right: 25%;
        transform: translate(8px, -6px);
      }

      &:hover {
        box-shadow: 0 0 0 3px rgba(98,0,238,.1);
      }

      &:active {
        box-shadow: 0 0 0 6px rgba(98,0,238,.2);
      }
    }
  }
</style>